import React, { Component } from 'react';

class LinesMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Página de linhas </h2>
                <p>
                    Nesta página encontra todas as linhas disponíveis na edição ativa na data seleciona. A página é dividida em linhas na rede ativa e linhas no rascunho.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar linhas na rede ativa e na de rascunho</li>
                    <li>Editar linhas na rede ativa e na de rascunho</li>
                    <li>Eliminar linhas na rede ativa e na de rascunho</li>
                    <li>Exportar as linhas existentes tanto na rede ativa como na de rascunho para um ficheiro CSV</li>
                    <li>Pesquisar as linhas disponíveis</li>
                    <li>Comparar as linhas da rede ativa com as linhas do rascunho </li>
                </ul>
            </div>
        );
    }
}

export default LinesMetadata;


// WEBPACK FOOTER //
// ./src/components/metadata/datamanager/LinesMetadata.js